/**
 * Module for capturing page transitions and reporting back to Google Analytics
 */
import './google-analytics-snippet';

import runPageAnalytics from './page-analytics.run';

import * as gzAnalytics from './analytics.service';
import * as gzAnalyitcsEvent from './analytics-event.directive';

export default angular.module('gazelle.core.analytics', [
  'angulartics',
  'rhino.components.application',
  'ui.router',
])
  .config(disableAngularticsPageTracking)
  .run(runPageAnalytics)
  .service(gzAnalytics.name, gzAnalytics.default)
  .directive(gzAnalyitcsEvent.name, gzAnalyitcsEvent.default)
  .name;

function disableAngularticsPageTracking($analyticsProvider) {
  'nginject';

  $analyticsProvider.firstPageview(false);
  $analyticsProvider.virtualPageviews(false);
}
